export default { loadScript, createLabel, determinInitialCenter }

function loadScript(callback, userAgent = false) {
  if (window.qq && window.qq.maps) {
    callback()
  } else {
    if (userAgent) {
      Object.defineProperty(window.navigator, 'userAgent', {
        value:
          'Mozilla/5.0 (Linux; U; Android 8.1.0; zh-cn; BLA-AL00 Build/HUAWEIBLA-AL00) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/57.0.2987.132 MQQBrowser/8.9 Mobile Safari/537.36',
        writable: false
      })
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = getSrcByKey(
      process.env.TENCENT_MAP_CLIENT_KEY
    );  
    
    script.crossOrigin = 'anonymous'
    document.body.appendChild(script)
    window.onQQMapReady = callback
  }

  function getSrcByKey(apiKey) {
    return (
      'https://map.qq.com/api/js?v=2.exp&key=' +
      apiKey +
      '&callback=onQQMapReady'
    )
  }
}

function createLabel(theMarker, theClass) {
  const labInfo = {
    X_Point: 0,
    Y_Point: 0,
    content: ''
  }

  // 字体满8个则拼接... 根据字体大小设置label偏移位置
  const labelLength = theMarker.title.toString().length
  let labelText = ''
  if (labelLength >= 6) {
    labInfo.X_Point = -105
    labInfo.Y_Point = -55
    labelText =
      theMarker.title.substr(0, 6) +
      '...' +
      ' ' +
      '<span class="smart_map_sub_title">' +
      '(' +
      theMarker.subTitle +
      '个)' +
      '</span>'
  } else if (labelLength >= 9 || labelLength <= 6) {
    labInfo.X_Point = -85
    labInfo.Y_Point = -55
    labelText =
      theMarker.title +
      ' ' +
      '<span class="smart_map_sub_title">' +
      '(' +
      theMarker.subTitle +
      '个)' +
      '</span>'
  } else {
    labInfo.X_Point = -55
    labInfo.Y_Point = -55
    labelText =
      theMarker.title +
      ' ' +
      '<span class="smart_map_sub_title">' +
      '(' +
      theMarker.subTitle +
      '个)' +
      '</span>'
  }
  labInfo.content = `<div class="${theClass}">` + labelText + '</div>'

  return labInfo
}

async function determinInitialCenter({
  markers, // marker数组
  initMarkerId, // 默认选重点
  perLocation, // 对比点
  $store // vuex 实例
}) {
  // 获取中心点优先级
  // 1. 初始选中点initMarkerId
  // 3. 通过对比点perLocation找到中心点
  let center
  if (initMarkerId) {
    center = find(markers, { markerId: initMarkerId })
  } else {
    // 通过对比点找到最近的点作为中心点
    let perMarker = {}

    if (isValidPoint(perLocation)) {
      perMarker = perLocation
    } else {
      // perMarker = await $store.dispatch('user/location/getLocation')
    }
    // 找到离对比点最近的点作为中心点
    center = getNearestPoint(markers, perMarker)
  }
  return center
}

/**
 * [isValidPoint description]
 * 判断是否是正常的经纬度
 * @author Hank
 * @date   2019-01-25T13:17:37+0800
 * @param  {[type]}                 point [description]
 * @return {Boolean}                      [description]
 */
function isValidPoint(point) {
  if (!point) return
  if (typeof point !== 'object') return

  if (Math.abs(point.latitude) + Math.abs(point.longitude) >= 0) return true
  return false
}

/**
 * [getNearestPoint description]
 * 在数组pointArr中找到一个离perPoint最近的点
 * @author Hank
 * @date   2019-01-25T13:18:07+0800
 * @param  {[type]}                 pointArr [description]
 * @param  {[type]}                 perPoint [description]
 * @return {[type]}                          [description]
 */
function getNearestPoint(pointArr, perPoint) {
  if (!pointArr || !perPoint || (pointArr && pointArr.length === 0))
    return perPoint
  // console.log('>>getNearestPoint-input', pointArr, perPoint);

  let minDistance = 0
  let nearestPoint
  for (let i = 0; i < pointArr.length; i++) {
    const point = pointArr[i]
    const distance = getDistance(
      perPoint.latitude,
      perPoint.longitude,
      point.latitude,
      point.longitude
    )
    // console.log('>>getNearestPoint-distance-',distance);
    if (i == 0) {
      minDistance = distance
      nearestPoint = point
    } else {
      const closer = distance < minDistance
      if (closer) {
        // console.log('>>getNearestPoint-found-', point, 'distance:', distance);
      }
      minDistance = closer ? distance : minDistance
      nearestPoint = closer ? point : nearestPoint
    }
  }
  return nearestPoint
}

/**
 * 计算两个经纬度的距离
 */
function getDistance(lat1, lng1, lat2, lng2) {
  const radLat1 = (lat1 * Math.PI) / 180.0
  const radLat2 = (lat2 * Math.PI) / 180.0
  const a = radLat1 - radLat2
  const b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0
  let s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.sin(a / 2) ** 2 +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(b / 2) ** 2
      )
    )
  s *= 6378.137 // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000
  return s
}
